<template>
  <transition name="slide">
    <el-dialog
      class="smart-search-popup sliding no-footer full-sliding"
      modal-class="sliding"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      :modal="true"
      top="0"
      @close="onClose"
      @open="onOpen"
    >
      <!-- title -->
      <el-row slot="title" type="flex" justify="space-between">
        <div v-if="showResult" class="search-header">
          <div class="logo" @click="logoClickToIntro">
            <img src="@/assets/img/smart-logo2.png" />
          </div>
          <w-search-input size="small" :keyword="keyword" @search-action="searchAction" />
        </div>
      </el-row>
      <!-- body -->
      <div class="body-content" style="background:#fff">
        <w-search-view ref="searchIntro" v-if="!showResult" @search-action="changeSearchView" @logo-click="logoClickToIntro" />
        <w-search-result-view ref="searchResult" v-if="showResult" :keyword="keyword" @search-related-obj="searchAction" />
      </div>
    </el-dialog>
  </transition>
</template>

<script>
import WSearchInput from './components/SearchInput';
import WSearchView from './SearchView';
import WSearchResultView from './SearchResultView';

export default {
  name: 'WSmartSearchPopup',
  components: {
    WSearchInput,
    WSearchView,
    WSearchResultView,
  },
  data() {
    return {
      /**
       * 팝업 display 여부
       * @type {Boolean}
       */
      visible: false,
      /**
       * 검색 키워드
       * @type {String}
       */
      keyword: '',
      /**
       * 검색 결과 제공 여부
       * @type {Boolean}
       */
      showResult: false,
    };
  },
  computed: {
    showSmartSearchPopup() {
      return this.$store.state.popup.showSmartSearchPopup;
    },
  },
  watch: {
    showSmartSearchPopup: {
      handler(value) {
        if (value) {
          this.open();
        } else {
          this.close();
        }
      },
    },
  },
  methods: {
    /**
     * 슬라이딩 팝업 열기
     */
    open() {
      this.visible = true;
      this.$emit('open');
    },
    /**
     * 슬라이딩 팝업 닫기
     */
    close() {
      this.visible = false;
      this.$emit('close');
    },
    /**
     * 팝업 열기 이벤트 핸들러
     */
    onOpen() {
      this.loadFrequentVisitPageData();
    },
    /**
     * 팝업 닫기 이벤트 핸들러
     */
    onClose() {
      this.reset();
      if (this.showSmartSearchPopup) {
        this.$store.dispatch('closeSmartSearchPopup');
      }
    },
    /**
     * 검색 초기화면 , 결과화면 전환
     * @author Hunui
     * @param  {[type]} searchKeyword 검색어
     */
    changeSearchView(searchKeyword) {
      this.keyword = searchKeyword;
      this.showResult = true;
    },
    /**
     * 결과 화면에서 검색을 실행
     * @author Hunui
     * @param  {[type]} searchKeyword 검색어
     */
    searchAction(searchKeyword) {
      this.keyword = searchKeyword;
      this.$refs.searchResult.searchAction(searchKeyword);
    },
    /**
     * 로고 클릭 시 초기화면으로 복귀
     * @author Hunui
     * @return {[type]} [description]
     */
    logoClickToIntro() {
      this.reset();
      this.loadFrequentVisitPageData();
    },
    /**
     * 자주 방문하는 페이지 데이터를 조회
     * @author Hunui
     * @return {[type]} [description]
     */
    loadFrequentVisitPageData() {
      this.$nextTick(() => {
        this.$refs.searchIntro.loadFrequentVisitPageData();
      });
    },
    /**
     * 검색 화면 초기화
     * @author Hunui
     */
    reset() {
      this.showResult = false;
      this.keyword = '';
      if (this.$refs.searchIntro) {
        this.$refs.searchIntro.reset();
      } else if (this.$refs.searchResult) {
        this.$refs.searchResult.reset();
      }
    },
  },
};
</script>

<style lang="scss">
.el-popper.info {
  .el-popover__title {
    font-size: 15px;
    font-weight: 500;
    color: #9ea1a5;
  }
  .info-title {
    background: #eef3fb;
    color: #5a74a5;
    display: inline-block;
    border-radius: 3px;
    font-size: 12px;
    padding: 2px 7px;
    margin-right: 5px;
  }
  li {
    // &:first-child {margin-top: 20px}
    list-style: none;
    line-height: 12px;
    padding: 2px 4px;
    &:before {
      content: '.';
      font-size: 20px;
      color: #9ea1a5;
      margin-right: 10px;
      position: relative;
      top: -3px;
    }
    .label {
      font-weight: 500;
      color: #5a74a5;
      margin-right: 3px;
    }
  }
}

.smart-search-popup {
  $bg-color: #f0f2f5;
  $active-color: #38608e;

  //첫화면 로고
  .wass-logo {
    width: 300px;
    height: 100px;
    margin: 10% auto 10px;
  }

  //연관검색어부분
  .related-info-container {
    width: 92%;
    margin-left: 38px;
    padding: 15px 0 12px;
    border-bottom: 1px solid #ebebeb;
    & > .title {
      color: #333;
      font-weight: 500;
    }
    .el-tag {
      margin: 0 3px;
      color: #777;
      border-color: #eee;
      background: #eee;
      cursor: pointer;
    }
  }

  // 검색 입력 컴포넌트
  .search-input {
    .el-input--medium {
      $search-input-box-shadow: 3px 2px 6px rgba(0, 0, 0, 0.15);
      .el-input__inner {
        height: 56px;
        line-height: 56px;
        font-size: 18px;
        font-weight: 300;
        padding-left: 18px;
        border: none;
        border-radius: 3px;
        box-shadow: $search-input-box-shadow;

        &:focus:active {
          box-shadow: $search-input-box-shadow !important;
        }
      }
      .el-input__suffix {
        right: 25px;
        color: #3290d2;
        font-size: 20px;
        margin-top: 3px;
      }
      .el-icon-search:before {
        // content: "\f061"
        // font-family: 'Font Awesome 5 Brands';
        font-weight: bold;
      }
    }

    .el-input--small {
      .el-input__inner {
        height: 40px;
        font-size: 15px;
        font-weight: 300;
        border: 1px solid #dcdfe6;
      }
      .el-input__prefix,
      .el-input__suffix {
        color: #3290d2;
        margin-right: 8px;
      }
    }

    .info-icon {
      display: none;
      color: #b7bdc7;
    }

    &:hover .info-icon {
      display: inline-block;
    }

    .info-icon.show-info-popper {
      display: inline-block;
    }
  }

  .el-dialog__header {
    background-color: $bg-color;
    border-bottom: none;
    height: 80px;

    //small 검색바
    .search-header {
      width: 100%;
      .el-autocomplete {
        top: -16px;
        width: 40%;
      }
      .logo {
        display: inline-block;
        cursor: pointer;
        margin: -3px 16px 0;
      }
    }
  }

  .body-content {
    padding: 0 !important;
    width: 100%;
    height: 100%;
  }

  // 초기 검색 화면
  .search-wrapper {
    background-color: $bg-color;
    height: 100%;
  }

  // 자주 방문하는 페이지
  .frequent-visit-page-wrapper {
    & > .el-row {
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-col-5 {
      width: 20%;
    }
    .title {
      font-size: 14px;
      color: #2a3346;
      font-weight: 500;
      margin: 4% 0
    }
    .page-box {
      cursor: pointer;
      .img {
        width: 70px;
        height: 74px;
        margin: 0 54px 10px;
        background: #d0d3d8;
        border-radius: 18px
      }
      .label {
        width: 100%;
        max-height: 34px;
        padding: 3px 10px 0;
        font-size: 12px;
        font-family: 'malgun', sans-serif;
        letter-spacing: -0.4px;
        text-align: center;
        line-height: 15px;
        text-overflow: ellipsis;
        overflow: hidden;
        //white-space: nowrap;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        color: #999;
      }

      &.empty {
        background: #e5e8eb;
        cursor: default;
      }
      &.empty:hover {
        background: #e5e8eb;
        box-shadow: none;
        border: none;
      }
      &:hover {
        .label {color:#86868b}
        .img {
           background: linear-gradient(0deg, rgb(52, 148, 214), rgb(70, 169, 238));
           box-shadow: 1px 0px 4px rgba(0, 0, 0, 0.3);
           transition: .3s ease;
        }
      }
    }
  }

  // 검색 결과 화면
  .search-result-wrapper {
    width: 100%;
    height: 100%;
    $menu-height: 50px;

    .search-menu {
      background-color: $bg-color;
      border-bottom: none;
      & > .el-menu-item {
        height: $menu-height;
        line-height: 60px;
        color: #333;
        font-size: 13px;
        &:first-child {
          margin-left: 34px;
        }
        &:hover {
          color: $active-color;
        }
        &.is-active {
          color: $active-color;
          font-weight: 600;
          background: $bg-color;
          border-bottom: 3px solid $active-color;
        }
      }
    }
    .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
      background: $bg-color;
    }
    .search-contents {
      width: 100%;
      height: calc(100% - #{$menu-height});

      .main {
        display: inline-block;
        min-width: 558px;
        width: calc(100% - 519px});

        .search-result-detail-wrapper {
          width: 98%;
          padding: 20px;
          margin-left: 18px;
          color: #333;

          $border-color: #ebebeb;

          .header {
            font-size: 14px;
            font-weight: 700;
            padding: 6px 0 12px;
          }

          .result-box {
            margin-bottom: 10px;
            font-size: 13px;

            .title {
              font-size: 14px;
              font-weight: 700;
              padding: 6px 0 10px;
            }
            .list li {
              list-style: none;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .item {
              // &:first-child {margin-top: 20px}
              list-style: none;
              padding: 4px 12px 4px 0;
              &:last-child {
                padding-bottom: 7px;
              }
              &:before {
                content: '.';
                font-size: 20px;
                color: #9ea1a5;
                margin-right: 10px;
                position: relative;
                top: -3px;
              }
            }
            &.border {
              border-radius: 6px;
              border: 1px solid $border-color;
              padding: 8px 12px;
              margin-bottom: 20px;

              .title {
                background: #f0f2f5;
                font-weight: 500;
                padding: 10px;
                margin: -8px -12px 10px;
              }

              .list {
                margin-left: 7px;
              }
            }
            .more {
              color: #3584d6;
              cursor: pointer;
              font-size: 12px;
            }
            .link {
              color: #315fa7;
              cursor: pointer;
            }
            .type {
              background: #eef3fb;
              color: #5a74a5;
              display: inline-block;
              border-radius: 3px;
              font-size: 11px;
              padding: 2px 7px;
              margin-right: 5px;
            }
            .last-label {
              display: inline-block;
              border-radius: 3px;
              background: #f5f6f9;
              padding: 0 6px;
            }
            .separator {
              color: #bebecc;
              margin: 0 6px;
            }

            .datetime {
              color: #afb0b1;
              margin-left: 5px;
            }

            .expand-button {
              cursor: pointer;
              color: #bec1c3;
              margin-left: 4px;
            }

            .link-button {
              color: #8c9094;
              font-size: 12px;
              cursor: pointer;
              margin-left: 4px;
            }

            .sub-result-box {
              margin: 10px 10px 5px 20px;
              padding: 7px 14px;
              border-left: 2px solid #dfe2e5;

              li {
                list-style: none;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding: 1px 0;
              }
            }
          }

          .no-data {
            text-align: center;
            width: 60%;
            min-width: 750px;
            margin-top: 62px;

            .main-text {
              margin-top: 20px;
              font-size: 16px;
              color: #7b8890;

              .keyword {
                color: #3290d2;
              }
            }

            .info {
              font-size: 13px;
              color: #b4b5bb;
              margin-top: 7px;
            }
          }
        }
      }

      .side {
        display: inline-block;
        // width: 26%;
        width: 515px;
        padding-right: 30px;
        // min-width: 300px;
        margin-top: 42px;
        float: right;
        .search-target-wrapper {
          border: 1px solid #e0e0e0;
          margin-bottom: 25px;
          .header {
            height: 67px;
            padding: 15px;
            background: #eee;
            border-bottom: 1px solid #e0e0e0;

            .title-wrapper {
              top: 4px;
              height: 100%;
              position: relative;

              .title-content {
                display: flex;
                height: 100%;

                .object-icon {
                  width: 40px;
                  height: 30px;
                  position: absolute;
                  color: #999;
                }

                .object-info {
                  display: grid;
                  width: 250px;
                  margin-left: 50px;
                }
                .object-info .ip {
                  font-size: 11px;
                  font-weight: 400;
                  color: #666;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                }
              }
            }
          }
          .body {
            padding: 0 5px;
          }
        }
        // end search-target-wrapper
      }
    }
  }
}
@media (max-width: 1400px) {
  .smart-search-popup .el-dialog__header .search-header .el-autocomplete {
    width: 62%;
  }
}
// 검색어 입력 컴포넌트 자동 완성
.el-autocomplete-suggestion.search-input {
  li {
    font-size: 13px;
    line-height: 29px;
  }
  .hist-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .label {
      position: relative;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      vertical-align: top;
    }
    .datetime {
      margin-left: 2px;
      margin-right: 5px;
      color: #afb0b1;
    }
    .delete-icon {
      display: inline-block;
      cursor: pointer;
      color: #8e8e8e;
    }
  }

  .autocomplete-item strong {
    font-weight: 700;
  }
}
@media only screen and (max-width: 1600px) {
  .wass-logo {margin: 0 auto !important}
  .smart-search-popup .frequent-visit-page-wrapper .title {
    margin: 2% 0
  }
}
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/SmartSearchPopup/index.vue